import SiteService from "../services/site.service";
import { config } from "../config/index";

const getBikesSlug = async () => {

   try {
      const bikes = await SiteService.getBikes(config.env)
      if (bikes) {
         return bikes.data
      }
   } catch (e) {
         //error
   }
}

export const dashboardRouters = [
  {
    path: '/painel/inicio',
    name: 'dashboard',
    component: () => import( '../views/dashboard/')
  },
  {
    path: '/painel/minha-conta/perfil',
    name: 'profile',
    component: () => import( '../views/dashboard/account/profile/')
  },
  {
    path: '/painel/minha-conta/seguranca',
    name: 'security',
    component: () => import( '../views/dashboard/account/security/')
  },
  {
    path: '/painel/minha-conta/verificacoes',
    name: 'verificacoes',
    component: () => import( '../views/dashboard/account/verificacoes/')
  },
  {
    path: '/painel/anunciante/:page',
    name: 'my-bikes',
    component: () => import('../views/dashboard/owner-panel/')
  },
  {
    path: '/painel/anunciante/minhas-bicicletas/bicicleta/:step/:id?',
    name: 'edit-bike',
    component: () => import('../views/dashboard/owner-panel/NewBike')
  },
  {
    path: '/painel/finalizar-cadastro/:step?',
    name: 'finalize-register',
    component: () => import('../views/dashboard/account/finalize-register')
  },
   {
      path: '/painel/anunciante/solicitar-saque/',
      name: 'request-withdrawal',
      component: () => import('../views/dashboard/account/finalize-register')
   },
  {
    path: '/painel/nova-bicicleta',
    name: 'new-bike',
    component: () => import('../views/dashboard/owner-panel/NewBike')
  },
  {
    path: '/painel/ciclista/minhas-reservas',
    name: 'my-reservations',
    component: () => import('../views/dashboard/cyclist-panel/my-reservations/')
  },
   {
      path: '/painel/ciclista/extrato',
      name: 'my-extract',
      component: () => import('../views/dashboard/cyclist-panel/extract')
   },
   {
      path: '/painel/chat',
      name: 'chat',
      component: () => import('../views/dashboard/conversations/')
   },
  {
    path: '/painel/avaliacoes',
    name: 'comments',
    component: () => import('../views/dashboard/cyclist-panel/comments/')
  },
  {
    path: '/painel/ciclista/cartoes',
    name: 'cards',
    component: () => import('../views/dashboard/cyclist-panel/cards')
  },
  {
    path: '/sair',
    name: 'logout',
    component: () => import('../views/dashboard/account/profile/Logout')
  }
];

export const siteRouters = [
  {
    path: '/',
    name: 'home',
    meta: { shouldTransition: false },
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/sobre',
    name: 'about',
    component: () => import('../views/About.vue')
  },
  {
    path: '/anuncie-sua-bicicleta',
    name: 'ads-your-bike',
    component: () => import('../views/AdsYourBike.vue')
  },
  {
    path: '/ajuda',
    name: 'help',
    component: () => import('../views/Help.vue')
  },
  {
    path: '/contato',
    name: 'contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
     meta: { sitemap: { ignoreRoute: true } },
  },
  {
      path: '/recuperar-senha',
      name: 'recover-password',
      component: () => import('../views/recoverPass.vue'),
      meta: { sitemap: { ignoreRoute: true } },
   },
  {
    path: '/recuperar-senha/token',
    name: 'recover-password-token',
    component: () => import('../views/NewPassword.vue'),
     meta: { sitemap: { ignoreRoute: true } },
  },
  {
    path: '/recuperar-senha/token/:token/email/:email',
    name: 'recover-password-token-id',
    component: () => import('../views/NewPassword.vue'),
     meta: { sitemap: { ignoreRoute: true } },
  },
  {
    path: '/registrar',
    name: 'register',
    component: () => import('../views/Register.vue'),
     meta: { sitemap: { ignoreRoute: true } },
  },
  {
    path: '/como-funciona-a-pedale',
    name: 'how-works',
    component: () => import('../views/HowWorks.vue')
  },
  {
    path: '/politicas-pedale/:page?',
    name: 'politics',
    component: () => import('../views/Politics.vue'),
     meta: { sitemap: { ignoreRoute: true } },
  },
  {
    path: '/bicicleta/:slug',
    name: 'bike',
    component: () => import('../views/Bike.vue'),
     meta: {
        sitemap: {
           slugs: async () => await getBikesSlug(),
        },
        transition: 'fade',
     }
  },
   {
      path: '/anunciante/:slug',
      name: 'advertiser',
      component: () => import('../views/Advertiser'),
      meta: { sitemap: { ignoreRoute: true } },
   },
  {
    path: '/checkout',
    name: 'checkout',
    component: () => import('../views/Checkout.vue'),
     meta: { sitemap: { ignoreRoute: true } },
  },
  {
    path: '/bicicletas/:city?/:coordinates?/:dates?',
    name: 'search',
    component: () => import('../views/Search.vue'),
     meta: { sitemap: { ignoreRoute: true }, transition: 'fade', },
  },
  {
    path: '/cartilha-anunciante/',
    name: 'advertiser-owner',
    component: () => import('../views/AdvertiserOwner.vue'),
     meta: { sitemap: { ignoreRoute: true } },
  },
   {
      path: '/cartilha-ciclista/',
      name: 'advertiser-customer',
      component: () => import('../views/AdvertiserCustomer.vue'),
      meta: { sitemap: { ignoreRoute: true } },
   },
];
